export default __webpack_public_path__ + "static/media/f5539b08bd2aa7b9915cc94cb340b66d.2f658fc8.png";